<template>
    <footer>
        <div class="container wsl-flex-middle-ng p-l-side wsl-p-r-20">
            <div class="t24">
                <span class="cb-blue Oswald-Medium">8 800 </span>
                <span class="cb-white Oswald-Medium">700 01 86</span>
            </div>

            <div class="t16 wsl-m-l-40 wsl-hide-xs">
                <span class="cb-white Oswald-Light">ООО “ЦентрБукинг.Ру”</span>
            </div>
            <div class="t16 wsl-m-l-auto wsl-show-xs">
                <span class="cb-white Oswald-Light">ООО “ЦентрБукинг.Ру”</span>
            </div>

            <div class="wsl-m-l-auto wsl-hide-xs">
                <div class="wsl-flex-middle-ng">
                    <img src="../assets/img/mastercard-securecode-white.png" alt="" class="wsl-m-x-15" style="height: 22px;">
                    <img src="../assets/img/verified-visa.png" alt="" class="wsl-m-x-15" style="height: 22px;">
                    <img src="../assets/img/MIR_accept.png" alt="" class="wsl-m-x-15" style="height: 22px;">
                </div>
            </div>

            <div class="wsl-m-l-auto wsl-hide-sm wsl-hide-xs">
                <a class="wsl-white wsl-hover Roboto" style="border-bottom: 1px dashed; ">Политика
                    конфиденциальности</a>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>

</style>
